import { render } from "./ImprestApproval.vue?vue&type=template&id=4686ce5e"
import script from "./ImprestApproval.vue?vue&type=script&lang=js"
export * from "./ImprestApproval.vue?vue&type=script&lang=js"

import "./ImprestApproval.vue?vue&type=style&index=0&id=4686ce5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__